import MenuInfo from '@/pages/menu/menuInfo'
import { MenuHeader } from '../menu/menuHeader'
import { useLocation } from 'react-router-dom'
import { useRef, useState } from 'react'
import BlogBoardList from './_components/blogBoardList'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'

const BlogBoard = () => {
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  return (
    <>
      <SEO
        title="소통"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/blog"
      />
      <div style={{ padding: isMobile ? '0 16px' : '0' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={true}
          menuInfoRef={menuInfoRef}
          loginRequired={true}
          iconActive={hasMenuInfo}
        />
      </div>
      <BlogBoardList />
      <div ref={menuInfoRef}>
        <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
      </div>
    </>
  )
}

export default BlogBoard
